export default __webpack_public_path__ + "static/media/rds.d4d4fe1f.svg";